import { useEffect, useState } from "react";
import { isEmpty } from "../../../utils/functions";

export default function SpanError({ text, className = '' }) {
    const [defaultClassname, setDefaultClassname] = useState('text-pink text-sm mt-1');

    useEffect(() => {
        if (!isEmpty(className)) {
            setDefaultClassname(className);
        }
    }, [className]);

    return (
        <p className={defaultClassname}>{text}</p>
    );
}